/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { FloatingPanelModel, IFloatingPanelParams, TFloatingPanelComponent } from "../FloatingPanel";
import {
	ISchemaConstString,
	ISchemaExpression,
	ISchemaExpressionBasedModel
} from "@adapptio/lib-blueprint";
import { FloatingPanelExpressionEditor } from "./FloatingPanelExpressionEditor";
import { IFieldCodeProps } from "@adapptio/lib-editor-ui";

export interface IFloatingPanelExpressionEditorParams extends IFloatingPanelParams {
	model: ISchemaExpressionBasedModel<ISchemaConstString | ISchemaExpression>;
	path: string[];
	readOnly?: boolean;
	debounceTimeout?: number;
	language?: IFieldCodeProps["language"];
	showStringValue?: boolean;
	onOuterReferenceClick?: IFieldCodeProps["onOuterReferenceClick"];
}

export class FloatingPanelExpressionEditorModel extends FloatingPanelModel<IFloatingPanelExpressionEditorParams> {
	getComponent(): TFloatingPanelComponent<FloatingPanelModel<IFloatingPanelExpressionEditorParams>> {
		return FloatingPanelExpressionEditor;
	}
}
